module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAD1BMVEUAAAB3d3d3d3d3d3d4eHiPLyTMAAAABHRSTlMAgEDAObvwrwAAADdJREFUeNrt0DUCAEEIA0AS+P+bz6pb12qZGo1sRFCqYPCi84qIHzXFD7/WMjRN8sS9KImgjLgA2f0BhUSCJCwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/十字.png
// module id = FBwY
// module chunks = 2